import { triggerCyclone } from "./states";

export const services = {
  triggerCyclone,
};
